// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__32dZS","footer":"ModalInfo_footer__3N_Ej"};